/* src/app/common/components/qr-scanner/qr-scanner.component.scss */
ion-content.class-view {
  background: transparent none !important;
  display: none;
}
/*# sourceMappingURL=qr-scanner.component.css.map */
